<div class="{{className}}" (click)="onClick()">
  <itb-icon [className]="searchBarButton.iconClassName"></itb-icon>
  <itb-text [className]="searchBarButton.textClassName" [text]="searchBarButton.text"></itb-text>
</div>